import styled from 'styled-components';

import media from '@/styles/media.style';

export const Section = styled.section`
  max-height: 900px;
  min-height: 300px;
  // IE 11 で見た時に詰まって見えるので、マージンを入れておく。
  margin-bottom: 20px;
  padding: ${({ scrollableX }) => (!scrollableX ? '20px 20px 0 20px' : '20px 0 0 20px')};
  width: 100%;

  ${media.tabletL`
    padding: 40px 0;
  `};
`;

export const Wrapper = styled.div`
  display: ${({ scrollableX }) => scrollableX && 'inline-block'};
  margin: auto;
  max-height: inherit;
  max-width: 1440px;
  width: 100%;
  white-space: ${({ scrollableX }) => scrollableX && 'nowrap'};
  overflow-y: hidden;
  overflow-x: scroll;
  // IE 対応 (スクロール非表示処理)
  -ms-overflow-style: none;
  // Firefox 対応 (スクロール非表示処理)
  scrollbar-width: none;
  // Chrome、Safari 対応 (スクロール非表示処理)
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const Outer = Wrapper.extend`
  max-width: 1060px;
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0;

  ${media.tabletL`
    padding: 0 8%;
  `};

  &.columnLessThanThree {
    justify-content: space-between;

    // デザイン調整のため、ここでのブレイクポイントは、tabletP (600 px) で設定。
    ${media.tabletP`
      justify-content: center;
    `};
  }
`;

export const PanelWrapper = styled.div`
  padding: 0 10px;
  max-width: 250px;

  &.columnOne {
    width: 100%;
    max-width: 100%;
  }

  ${media.tabletL`
    &.columnOne {
      padding: 0 20px;
      width: 40%;
    }
  `};
`;

export const PanelImage = styled.img`
  width: 235px;
  margin-bottom: 20px;

  &.columnOne {
    width: 100%;
  }

  ${media.tabletL`
    width: 100%;
  `};
`;

export const PanelTitle = styled.div`
  margin-bottom: 20px;
`;

export const PanelDescription = styled.div`
  margin-bottom: 20px;
`;

export const MarkdownStyle = styled.div`
  > p {
    font-size: 14px;
    line-height: 1.29;
    letter-spacing: 0.6px;
    white-space: pre-wrap;
    word-break: break-word;

    ${media.tabletL`
      font-size: 18px;
      line-height: 1.39;
      letter-spacing: 0.1px;
    `};
  }
`;



// WEBPACK FOOTER //
// ./src/components/Article/ImagePanelsSection.style.js